import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AppService } from '@mova/components/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

    constructor( private _appService: AppService, private http: HttpClient, private _apiService: ApiService) {}

    private path: string = '/recaptchas';
    private url: string = this._apiService.server+this.path;

    /**
   * Valida el valor del captcha.
   */
    captchaValidations$ (captcha: string): Observable<any[]> {
      
      

      let headersCpatcha = new HttpHeaders({
        'Content-Type': 'application/json',
        'clave': '83x6LOxkwzVe',
        'usuario': 'CUDI_APP',
        'apikey': environment.apiKey,
        'Authorization': 'Basic '+environment.apiKey,
        'mv-hide-error': 'true',
        'captcha-google': captcha
      });

      return this.http.get<any>(this.url, {headers: headersCpatcha});
    };
}
